import { LiftStationFormFields } from '@Types/stations.types';
import { FormikProps } from 'formik';
import React, { useEffect } from 'react';

interface Args {
	setIsValid?: React.Dispatch<React.SetStateAction<boolean>>;
	setStationName?: React.Dispatch<React.SetStateAction<string>>;
	formikProps: FormikProps<LiftStationFormFields>;
}

export default function usePropagateFormikDependantStations({
	setIsValid,
	formikProps,
	setStationName,
}: Args) {
	// Propagate isValid, to block the submit button in the PageWrapper
	useEffect(() => {
		setIsValid &&
			setIsValid(
				!formikProps.errors.name &&
					!formikProps.errors.type &&
					!formikProps.errors.location &&
					!formikProps.errors.sensors &&
					!formikProps.errors.sensorGroups &&
					!!formikProps.values.name.trim(),
			);
	}, [
		formikProps.errors.name,
		formikProps.errors.type,
		formikProps.errors.location,
		formikProps.errors.sensors,
		formikProps.errors.sensorGroups,
		formikProps.values.name,
	]);
	useEffect(() => {
		setStationName && setStationName(formikProps.values.name);
	}, [formikProps.values.name]);
}
